// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.lease.LeasingCheckPaymentsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { LeasingCheckActivePaymentsResponseDto } from '../..';

interface CheckActivePaymentsParams {
  leaseId: number;
}

export const LeasingCheckPaymentsWebApiHandler_checkActivePayments_Path = '/api/web/v1/lease/checkActivePayments';

/**
 * check if payments are active for a lease
 */
export const LeasingCheckPaymentsWebApiHandler_checkActivePayments = (
  getParams: CheckActivePaymentsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<CheckActivePaymentsParams, never, LeasingCheckActivePaymentsResponseDto>(
    {
      getParams: getParams,
      endpoint: LeasingCheckPaymentsWebApiHandler_checkActivePayments_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};
